import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { can, Permission } from '../auth/roles';
import { Loading } from './ui/States';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div style={{ padding: 40 }}><Loading height={200} /></div>;
  if (!session) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return <>{children}</>;
}

/** Route-level permission check; the subgraphs enforce the same rule with @Roles. */
export function RequirePermission({ perm, children }: { perm: Permission; children: ReactNode }) {
  const { session } = useAuth();
  if (!can(session?.role, perm)) return <Forbidden />;
  return <>{children}</>;
}

export function Forbidden() {
  return (
    <div className="card state" style={{ padding: 48 }}>
      <h2>No access</h2>
      <p>Your role does not include this section. Ask an admin if you need it.</p>
    </div>
  );
}
